import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { BorrowerTasksView } from 'borrower/domains/page/ui/BorrowerTasksView';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';

import 'source/borrower/borrower.scss';

export const BorrowerTasksRoute = () => {
  const toast = useToast();
  const history = useHistory();
  // Use this variable for errors that bubble up to the component level route
  // This ensures we only toast the error once when there are multiple errors
  // We should use Chakra's toast.isActive, or a react hook in general, but the state re-renders when there are multiple errors in a given error boundary
  let routeLevelError = false;
  return (
    <Box className="main">
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load tasks page`;
            routeLevelError = true;
            toast(errorToastConfig);
            history.push('/');
          }
        }}
      >
        <BorrowerTasksView />
      </Sentry.ErrorBoundary>
    </Box>
  );
};
